import webApi from './api'

export class BuyerPortalService {
  async healthCheck(params) {
    return webApi.get('buyer-portal-api/healthcheck', { params })
  }
}

const buyerPortalService = new BuyerPortalService()

export default buyerPortalService; 